import App from 'antd/lib/app';
import { ExportButton, IExportButtonProps } from '../../../../components/ExportButton/ExportButton';
import { useExportPjmLocationsQuery } from 'src/domain/pjm/queries';

export interface PjmLocationsExportButtonProps {
    filter: Record<string, string | number>;
}

export const PjmLocationsExportButton = ({ filter }: PjmLocationsExportButtonProps) => {
    const { notification } = App.useApp();

    const exportPjmLocationsAllQuery = useExportPjmLocationsQuery({ include: 'registration' });
    if (exportPjmLocationsAllQuery.isError) {
        notification.error({
            key: 'fetch-pjm-locations-error',
            message: exportPjmLocationsAllQuery.error.message || 'Cannot export data!',
        });
    }

    const exportPjmLocationsQuery = useExportPjmLocationsQuery(filter);
    if (exportPjmLocationsQuery.isError) {
        notification.error({
            key: 'fetch-pjm-locations-error',
            message: exportPjmLocationsQuery.error.message || 'Cannot export data!',
        });
    }

    const exportPjmLocationsAll = async () => {
        await exportPjmLocationsAllQuery.refetch();
    };

    const exportPjmLocationsFiltered = async () => {
        await exportPjmLocationsQuery.refetch();
    };

    const actions: IExportButtonProps['actions'] = [
        {
            key: 'e-b-1',
            title: 'Download XLSX',
            fn: exportPjmLocationsAll,
        },
        {
            key: 'e-b-2',
            title: 'Download Filtered Data in XLSX',
            fn: exportPjmLocationsFiltered,
        },
    ];

    return <ExportButton actions={actions} />;
};
